import React from 'react';
import  styles from './styles/MapComponentStyles';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import GooglePinIcon from 'material-ui/svg-icons/communication/location-on';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import {darkBlack} from 'material-ui/styles/colors';
import {Link} from 'react-router';
import IconButton from 'material-ui/IconButton';

import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';

class GoogleInfoBox extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            expanded: true,
          };

        this.handleExpandChange = this.handleExpandChange.bind(this);
    }

    handleExpandChange = (expanded) => {
        console.info("expanded");
        this.setState({expanded: expanded});
    };

    render() {
        console.info("google map info windows rendered");

        const {translate, dateTime, position, addres, icnPlus, speed, preCrashSpeed, unitOfMeaserLabel, pdof, severity, icnId, withIcnLink} = this.props;
        return (
            <div style={styles.pinContainer} >

                <Card initiallyExpanded={true} >
                        <CardHeader
                            title={translate('DetailsPage.crashEventDetailsTitle')}
                            subtitle={dateTime}
                            avatar={<GooglePinIcon />}
                            actAsExpander={false}
                            showExpandableButton={false}
                        />
                        <CardText expandable={true} style={{paddingTop: 0, backgroundColor: 'transparent'}}>
                            <List >
                                {
                                    icnId && withIcnLink?
                                    <div>
                                        <ListItem
                                            hoverColor={'transparent'}
                                            innerDivStyle={styles.listItemView}
                                            secondaryText={
                                                <p style={styles.listItemViewParagraphWithLink}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.icnId')}:&nbsp;&nbsp;
                                                    </span>
                                                    <Link to={"predictivephysicaldamage/details/" + icnId} >
                                                        {icnId}
                                                        <IconButton
                                                                style={{position: 'relative', top: 6}}
                                                                iconClassName="material-icons">
                                                                keyboard_arrow_right
                                                        </IconButton>
                                                    </Link>
                                                </p>
                                            }
                                            secondaryTextLines={2}
                                        />
                                        <Divider/>
                                    </div>
                                    :null
                                }
                                {
                                    icnId && !withIcnLink?
                                    <div>
                                        <ListItem
                                            hoverColor={'transparent'}
                                            innerDivStyle={styles.listItemView}
                                            secondaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.icnId')}:&nbsp;&nbsp;
                                                    </span>
                                                    <span>
                                                        {icnId}
                                                    </span>
                                                </p>
                                            }
                                            secondaryTextLines={2}
                                        />
                                        <Divider/>
                                    </div>
                                    :null
                                }

                                <ListItem
                                    hoverColor={'transparent'}
                                    innerDivStyle={styles.listItemView}
                                    secondaryText={
                                        <p style={styles.listItemViewParagraph}  >
                                            <span style={{color: darkBlack}}>
                                            {translate('GLOBAL.deviceMapPosition')}:&nbsp;&nbsp;
                                            </span>
                                            lat: {position.lat.toFixed(3)}, long: {position.lng.toFixed(3)}
                                        </p>
                                    }
                                    secondaryTextLines={2}
                                />
                                {
                                    addres &&
                                    <div>
                                        <Divider/>
                                        <ListItem
                                            hoverColor={'transparent'}
                                            innerDivStyle={styles.listItemView}
                                            secondaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.address')}:&nbsp;&nbsp;
                                                    </span>
                                                    {addres}
                                                </p>
                                            }
                                            secondaryTextLines={2}
                                        />
                                    </div>
                                }
                                {
                                    preCrashSpeed !== undefined ?
                                    <div>
                                        <Divider/>
                                        <ListItem
                                            hoverColor={'transparent'}
                                            innerDivStyle={styles.listItemView}
                                            secondaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.preCrashSpeed')}:&nbsp;&nbsp;
                                                    </span>
                                                    <span>
                                                        {preCrashSpeed.toFixed(1)}&nbsp;{unitOfMeaserLabel}
                                                    </span>
                                                </p>
                                            }
                                            secondaryTextLines={2}
                                        />
                                    </div>
                                    : null
                                }
                                {
                                    speed !== undefined  ?
                                    <div>
                                        <Divider/>
                                        <ListItem
                                            hoverColor={'transparent'}
                                            innerDivStyle={styles.listItemView}
                                            secondaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('ChartsForm.speed')}:&nbsp;&nbsp;
                                                    </span>
                                                    <span>
                                                        {speed.toFixed(1)}&nbsp;{unitOfMeaserLabel}
                                                    </span>
                                                </p>
                                            }
                                            secondaryTextLines={2}
                                        />
                                    </div>
                                    : null
                                }
                                {
                                    icnPlus ?
                                    <div>

                                        <Divider/>
                                        <ListItem
                                            hoverColor={'transparent'}
                                            innerDivStyle={styles.listItemView}
                                            secondaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('DetailsPage.crashDirection')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icnPlus.crashDirection}
                                                </p>
                                            }
                                            secondaryTextLines={2}
                                        />
                                        <Divider/>
                                        <ListItem
                                            hoverColor={'transparent'}
                                            innerDivStyle={styles.listItemView}
                                            secondaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.pdof')}:&nbsp;&nbsp;
                                                    </span>
                                                    {icnPlus.pdof.toFixed(1)}&nbsp;{translate('GLOBAL.degree')}
                                                </p>
                                            }
                                            secondaryTextLines={2}
                                        />
                                        {
                                            pdof ?
                                            <div>
                                                <Divider/>
                                                <ListItem
                                                    hoverColor={'transparent'}
                                                    innerDivStyle={styles.pdoflistItemView}
                                                    secondaryText={
                                                        <p style={styles.pdoflistItemViewParagraph}  >
                                                            <img width={100} src={`data:image/jpeg;base64,${pdof}`} alt="primary direction of force" />
                                                        </p>
                                                    }
                                                    secondaryTextLines={2}
                                                />
                                            </div>
                                            :null
                                        }


                                    </div>
                                    : null
                                }
                                {
                                    severity?
                                    <div>
                                        <Divider/>
                                        <ListItem
                                            hoverColor={'transparent'}
                                            innerDivStyle={styles.listItemView}
                                            secondaryText={
                                                <p style={styles.listItemViewParagraph}  >
                                                    <span style={{color: darkBlack}}>
                                                        {translate('GLOBAL.crashSeverity')}:&nbsp;&nbsp;
                                                    </span>
                                                    {severity}
                                                </p>
                                            }
                                            secondaryTextLines={2}
                                        />

                                    </div>
                                    :null
                                }
                            </List>
                        </CardText>
                </Card>
            </div>
        );
    }
}

GoogleInfoBox.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    console.info(state);
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    }
}
export default connect(mapStateToProps, null)(GoogleInfoBox);


// WEBPACK FOOTER //
// ./src/components/maps/GoogleInfoBox.js